import { EQuestionnairePath, type TQuestionnairePath } from "./questionnaire-flow";

const QUESTIONNAIRE_PATH_ALIASES: Record<string, TQuestionnairePath> = {
	fund: EQuestionnairePath.FUND,
	pay: EQuestionnairePath.PAYMENTS,
	payments: EQuestionnairePath.PAYMENTS,
	grow: EQuestionnairePath.CASH_FLOW,
	cashFlow: EQuestionnairePath.CASH_FLOW,
};

/** Canonical path plus short `?path=` aliases (`pay`, `grow`). */
export function parseQuestionnairePathParam(value: string | null): TQuestionnairePath | null {
	if (!value) return null;
	return QUESTIONNAIRE_PATH_ALIASES[value] ?? null;
}

/** Deep-link the questionnaire page with a chosen path pre-selected. */
export function questionnaireChoiceHref(baseHref: string, path: TQuestionnairePath): string {
	const separator = baseHref.includes("?") ? "&" : "?";
	return `${baseHref}${separator}path=${encodeURIComponent(path)}`;
}

/** Reads the deep-link `?path=` on the standalone questionnaire page. */
export function readQuestionnairePathParam(): TQuestionnairePath | null {
	if (typeof window === "undefined") return null;
	return parseQuestionnairePathParam(new URLSearchParams(window.location.search).get("path"));
}

/** Clears the deep-link param once the flow is dismissed, so a refresh shows the picker. */
export function clearQuestionnairePathParam(): void {
	if (typeof window === "undefined") return;
	const url = new URL(window.location.href);
	url.searchParams.delete("path");
	window.history.replaceState(null, "", url);
}
